import { FormikProps } from 'formik'
import * as React from 'react'
import TextField from '../ui/TextField'
import GenericDropdown from '../ui/GenericDropdown'
import { IMap, IVehicleMake } from 'src/types'

interface IServiceProgramFormProps {
  formikProps: FormikProps<any>
  children: React.ReactNode
  makeList?: IMap<IVehicleMake>
}

const ModelForm = (props: IServiceProgramFormProps) => {
  const makes: Array<{
    label: string
    value: any
  }> = []
  if (props.makeList) {
    for (const i of Object.keys(props.makeList)) {
      makes.push({
        label: props.makeList[i].name,
        value: props.makeList[i].id
      })
    }
  }
  return (
    <form onSubmit={props.formikProps.handleSubmit}>
      <div className='mb3'>
        <TextField
          title='Model'
          name={'model'}
          optional={false}
          error={props.formikProps.errors.model}
          // classNameContainer={'mr1'}
          touched={props.formikProps.touched.model}
          onChange={props.formikProps.handleChange}
          value={props.formikProps.values.model}
          // className='border-light-grey4 rounded h5'
          placeholder='Model'
        />
      </div>
      <div className='mb3'>
        <div className='h6'>Make</div>
        <GenericDropdown name='make' options={makes} defaultOption={makes[0]} placeholder='Make' />
      </div>
      {props.children}
    </form>
  )
}

export default ModelForm



// WEBPACK FOOTER //
// ./src/components/global-settings/ModelForm.tsx